"use strict";

exports.__esModule = true;
var _SlidingInterval = require("./SlidingInterval");
Object.keys(_SlidingInterval).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SlidingInterval[key]) return;
  exports[key] = _SlidingInterval[key];
});